export var TypeActionNoOp;
(function (TypeActionNoOp) {
    TypeActionNoOp["NoOp"] = "NoOp > NoOp";
})(TypeActionNoOp || (TypeActionNoOp = {}));
export var actionNoOp = function () { return ({
    type: TypeActionNoOp.NoOp,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/no-op/actionNoOp.ts
// module id = 1700
// module chunks = 3